import { createLazyFileRoute } from "@tanstack/react-router";
import { memo } from "react";

import { ReportsPage } from "@/features/reports/routes/Reports";
import { NavStackProvider } from "@/utils/useNavStack";

export const Route = createLazyFileRoute("/_auth/_app/reports/")({
  component: memo(ReportsRoot),
});

function ReportsRoot() {
  return (
    <NavStackProvider label="Reports" href={{ to: "/reports" }}>
      <ReportsPage />
    </NavStackProvider>
  );
}
